<template>
    <div>
        <chart :chartData="chartData"/>
    </div>
</template>

<script>
    import Chart from '../StatisticalInformation/Chart.vue';
    export default {
        props: ['data'],
        components: {
            Chart
        },
        computed: {
            chartData() {
                return {
                    chart: {
                        type: 'bar',
                        plotBackgroundColor: null,
                        plotBorderWidth: 0,
                        plotShadow: false,
                        backgroundColor: null,
                        height: 70
                    },
                    exporting: {
                        enabled: false
                    },
                    legend: {
                        enabled: false
                    },
                    title: {
                        text: undefined
                    },
                    xAxis: {
                        visible: false
                    },
                    yAxis: {
                        title: undefined,
                        labels: {
                            enabled: false
                        },
                        plotLines: [
                            {
                                dashStyle: 'Solid',
                                color: '#808080',
                                value: 50,
                                width: 2,
                                zIndex: 4
                            }
                        ]
                    },
                    plotOptions: {
                        bar: {
                            stacking: 'percent',
                        },
                    },
                    tooltip: {
                        formatter: function () {
                            return `${this.point.percentage.toFixed(2)}% - ${this.y} votes - (${this.series.userOptions.party})`
                        }
                    },
                    series: [...this.data]
                        .reverse().map((d, i) => ({
                        name: d.Candidate,
                        dataLabels: {
                            enabled: true,
                            align: i === 0 ? 'right' : 'left',
                            format: '{point.percentage:.2f}%'
                        },
                        color: d.PartyColour,
                        party: d.Party,
                        data: [d.Votes]
                    }))
                }
            },
        }
    }
</script>